const textAlignmentOptions = {
  "center top": { justify: "start", align: "center" },
  "center center": { justify: "center", align: "center" },
  "center bottom": { justify: "end", align: "center" },
  "top right": { justify: "start", align: "end" },
};

export const getVerticalAlignment = (
  alignmentOp: keyof typeof textAlignmentOptions,
): string => {
  return textAlignmentOptions[alignmentOp]?.justify || "center";
};

export const getHorizontalAlignment = (
  alignmentOp: keyof typeof textAlignmentOptions,
): string => {
  return textAlignmentOptions[alignmentOp]?.align || "center";
};

export const getHeadingAlignment = (
  alignmentOp: string,
): "right" | "center" => {
  return alignmentOp === "top right" ? "right" : "center";
};
